import { ApiRequestOptions } from '@api/core/ApiRequestOptions';
import { getRequestOptions } from '@api/core/utils';

import type { CallMeFormRequestViewModel } from '../models/CallMeFormRequestViewModel';
import type { CallMeFormViewModel } from '../models/CallMeFormViewModel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class TicketsService {
  /**
   * Call Me
   * Call me form process for C4C
   * @returns CallMeFormViewModel OK
   * @throws ApiError
   */
  public static async callMeForm(
    {
      requestBody,
    }: {
      /**
       * Call Me Form Request View Model
       */
      requestBody?: CallMeFormRequestViewModel;
    },
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<CallMeFormViewModel> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<CallMeFormViewModel>({
      method: 'POST',
      url: `/tickets/callme`,
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
      headers: getRequestOptions(headers, 'headers'),
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }
}
